module.exports = __webpack_public_path__ + "static/media/video-frame.d77d44df.jpg";